export const constants = {
  ROOM_FEATURES_CODES: ['CR', 'RB', 'EP', 'EF', 'FP', 'FF'],
  STAY_CODES: ['EC'],
  BATHROOM_CODES: ['ET'],
  FEATHER_CODES: ['EP', 'FF'],
  FEATHER_PILLOW_CODE: 'EP',
  PILLOW_CODES: ['EP', 'FP', 'EF'],
  HOUSEKEEPING_OPT_IN: 'HA',
  HOUSEKEEPING_CODES: ['HD', 'HA'],
  HOUSEKEEPING_OPT_OUT: 'HD',
  MARRIOTT_BRAND_CODE: 'MC',

  // Housekeeping codes
  HK_EXCLUDED_BRAND_LIST: ['ER', 'MV', 'RZ', 'EB', 'WH', 'LC', 'XR', 'JW', 'BG'],

  // brands that need to redirected to the landing page instead of the reviews page
  HWSLandingPageRedirectionBrands: ['RZ', 'MV', 'DS', 'BG'],

  // Room Preferences Codes
  PREFERENCES_EXCEPTION_CODE: ['S5', 'D7', 'D9', 'N8', 'U2', 'W5', 'UR', 'M2'],
  ROOM_LOCATIONS_CODES: ['H1', 'L2', 'NE'],
  FLOOR_CODES: ['L2', 'H1'],

  ADDITIONAL_RF: 'RF',

  // Payment Codes
  PLUS_PAYMENT_METHOD_CODE_TYPE: 'SpecialIndustryProgram',
  PAYMENT_METHOD_CODE_TYPE_DEPOSITE: ['Cash', 'PrePay', 'Deposit'],
  PAYMENT_METHOD_CODE_TYPE_GUARANTEE: [
    'DirectBill',
    'Voucher',
    'CreditCard',
    'TravelAgencyIATANumber',
    'FrequentGuestNumber',
    'SpecialIndustryProgram',
    'CompanyNameOrAddress',
    'CorporateIDOrCDNumber',
    'OtherInformation',
    'PaymentManager',
  ],
  DEFAULT_PMT: 'CreditCard',
  PAYMENT_METHOD_CODE_TYPE_DEPOSIT_PREPAY: 'Deposit',

  HOTEL_ICON_CODES: {
    HOTEL_SERVICES: 'SA',
    HOTEL_HIGHLIGHTS: 'HH',
    PARKING: 'PT',
    HOUSEKEEPING: '10',
  },
  GUEST_ROOM_FIELD: 'ASP301',

  // New Error Framework
  ACRS_ERROR_CODES: [
    'ACS064',
    'ACS068',
    'ACS119',
    'AMP064',
    'AMP068',
    'ANR064',
    'ANR068',
    'ASP042',
    'ASP064',
    'ASP068',
    'GCM066',
    'ORD-RDS-RCM038',
    'ORD-RDS-RCM042',
    'ORD-RDS-RCM064',
    'ORD-RDS-RCM066',
    'ORD-RDS-RCM068',
    'ORD-RDS-RCM071',
    'ORD-RDS-RCM082',
    'RCM038',
    'RCM042',
    'RCM064',
    'RCM066',
    'RCM068',
    'RCM071',
    'RCM082',
    'RIS038',
    'RIS042',
    'RIS064',
    'RIS066',
    'RIS068',
    'RIS071',
    'RIS082',
    'RLK038',
    'RLK042',
    'RLK064',
    'RLK066',
    'RLK068',
    'RLK071',
    'RLK082',
    'RQS068',
    'RXS038',
    'RXS042',
    'RXS064',
    'RXS066',
    'RXS068',
    'RXS071',
    'RXS082',
  ],

  // ACRS group Error Codes
  ACRS_GROUP_ERROR_CODES: ['ASP042', 'ASP195'],

  // Preferences arrtribute code mapper for ACRS
  PREFERENCES_ATTRIBUTE_CODES: {
    A5: 'ACC002',
    K1: 'BED002',
    D4: 'BED006',
    H1: 'FLOOR124',
    S7: 'SMK',
    N3: 'NSMK',
    L2: 'FLOOR132',
  },
};
